import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useDemoStore = defineStore('demo', () => {
  // State
  const isDemoMidGame = ref(false);
  const returnFromDemo = ref(false);
  const demoCompleted = ref(false);
  const processingPlayTransition = ref(false);

  // Actions
  function setIsMidGameDemo(value: boolean) {
    isDemoMidGame.value = value;
    console.log('Demo Store: Set isDemoMidGame to', value);
  }

  function setReturnFromDemo(value: boolean) {
    returnFromDemo.value = value;
    console.log('Demo Store: Set returnFromDemo to', value);
  }

  function setDemoCompleted(value: boolean) {
    demoCompleted.value = value;
    console.log('Demo Store: Set demoCompleted to', value);
  }

  function setProcessingPlayTransition(value: boolean) {
    processingPlayTransition.value = value;
  }

  function resetDemoState() {
    console.log('Demo Store: Resetting all state');
    console.log('Previous state was:', {
      isDemoMidGame: isDemoMidGame.value,
      returnFromDemo: returnFromDemo.value,
      demoCompleted: demoCompleted.value,
      processingPlayTransition: processingPlayTransition.value,
    });

    isDemoMidGame.value = false;
    returnFromDemo.value = false;
    demoCompleted.value = false;
    processingPlayTransition.value = false;

    console.log('Demo Store: State reset complete');
  }

  // Reset state for game change - will completely clean all flags
  function resetForGameChange() {
    console.log('Demo Store: Resetting state for game change');
    isDemoMidGame.value = false;
    returnFromDemo.value = false;
    demoCompleted.value = false;
    processingPlayTransition.value = false;
    console.log('Demo Store: Game change reset complete');
  }

  return {
    // State
    isDemoMidGame,
    returnFromDemo,
    demoCompleted,
    processingPlayTransition,

    // Actions
    setIsMidGameDemo,
    setReturnFromDemo,
    setDemoCompleted,
    setProcessingPlayTransition,
    resetDemoState,
    resetForGameChange,
  };
});
